export const USERS_ALLOWED_TO_USE_WIX_REPO = [
  'serhii.boreiko@usercentrics-ext.com',
  'aleksandar.lukic@usercentrics.com',
  'kristian.jakobsen@usercentrics.com',
  'michel.gammelgaard@usercentrics.com',
  'phillip.danielsen@usercentrics.com',
  'steffen.kromann@usercentrics.com',
];
